<script lang="ts">
    import type {TabId, TabPageDefinitionsMap} from 'shared/ui-widgets/tabset/types';

    export let tabs: TabPageDefinitionsMap;
    export let activeTab: TabId;
</script>

<svelte:component this="{tabs[activeTab].component}" {...tabs[activeTab].props ?? {}}/>
